import React from "react";
import { useMediaQuery } from "react-responsive";
import { Provider as JotaiProvider } from "jotai";
import { DetalleEntrevistaPageMovil, DetalleEntrevistaPageWeb } from "./componentes";

const DetalleEntrevistaPage = () => {
	const esMovil = useMediaQuery({ query: "(max-width: 860px)" });
	const esDesktop = useMediaQuery({ query: "(min-width: 860px)" });

	return (
		<JotaiProvider>
			{esMovil && <DetalleEntrevistaPageMovil />}
			{esDesktop && <DetalleEntrevistaPageWeb />}
		</JotaiProvider>
	);
};

export default DetalleEntrevistaPage;
